<div
  class="header-search flex-fill"
  (click)="openSearch($event)"
>
  <div
    [class.visible]="visible"
    class="header-search__contents"
  >
    <mat-icon
      aria-hidden="false"
      class="material-symbols-outlined"
      aria-label="Search icon"
      fontIcon="search"
      data-testId="header-search-collapse-input-trigger"
      (click)="openSearch($event)"
    ></mat-icon>
    <input
      type="text"
      #searchInput
      data-testId="header-search-input"
      [value]="searchValue"
      (keyup)="onKeyUp($event)"
      (blur)="closeSearch()"
      (input)="onSearchChange($event)" />
  </div>
</div>
